<script setup>

</script>
<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <!-- <div class="text-sm text-center copyright text-muted" :class="isRTL ? 'text-lg-end' : 'text-lg-start'">
            ©
            {{ new Date().getFullYear() }}, Todos os direitos reservados.
            <a href="https://www.brasal.com.br/incorporacoes" class="font-weight-bold" target="_blank">Brasal
              Incorporações.</a>
          </div> -->
        </div>
      </div>
    </div>
  </footer>
</template>
